import { iso8601DurationToYearsMonthsDays } from 'shared/lib';
import { getTermByPeriod } from 'shared/lib/dates/getTermByPeriod';
import type { TLoansCalculationCustomerData } from 'shared/types/TLoansService';

import { validateIso8601Period } from './validateIso8601Period';

/**
 * ISO 8601 DURATION в количество месяцев/дней для заявки в loans
 * @example "P5Y" => { term: 60, termUnit: 'month' }
 */
export const iso8601DurationToLoansTerm = (
  isoDuration?: string,
  termUnit?: TLoansCalculationCustomerData['termUnit'],
): Pick<TLoansCalculationCustomerData, 'term' | 'termUnit'> => {
  const isValid = validateIso8601Period(isoDuration);

  if (!isValid) {
    return {
      term: 0,
      termUnit: termUnit || 'month',
    };
  }

  if (termUnit) {
    return {
      termUnit,
      term: getTermByPeriod(termUnit, isoDuration),
    };
  }

  const { days, months, years } = iso8601DurationToYearsMonthsDays(isoDuration);

  const totalMonths = years * 12 + months;

  return {
    term: totalMonths || days,
    termUnit: totalMonths ? 'month' : 'day',
  };
};
